import React from 'react';
import styled from 'styled-components';

import InfoCircleSrc from 'assets/info-circle.png';

import { leaseCreatorColors } from 'helpers/ColorHelper';

const StyledMessageContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledMessage = styled.div`
  font-size: ${props => props.size || '14px'};
  line-height: 22px;
  color: ${leaseCreatorColors.INFO_MSG_COLOR};
  margin-left: 5px;
`;

const InfoMessage = ({ message, fontSize = '14px', iconSize = 14 }) => {
  return (
    <StyledMessageContainer>
      <img alt="info" src={InfoCircleSrc} width={iconSize} height={iconSize} />
      <StyledMessage size={fontSize}>{message}</StyledMessage>
    </StyledMessageContainer>
  );
};

export { InfoMessage };
